import React from 'react';
import c from '../w.js';

const IconCheckboxIndeterminate = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM12 11H6V13H12H18V11H12Z"
      }
    )
  )
);

export { IconCheckboxIndeterminate };
